export default {
  getItem(key, notJson) {
    const localStorage = window.localStorage.getItem(key);

    if(!notJson)
      return JSON.parse(localStorage);
    else
      return localStorage;
  },
  setItem(key, item) {
    window.localStorage.setItem(key, JSON.stringify(item));
  },
  removeItem(key) {
    window.localStorage.removeItem(key);
  },
  getSession() {
    return this.getItem("SESSION_INFO_STORAGE_KEY");
  },
  getUser() {
    var session = this.getSession();
    return session ? session.userId : "";
  },
  destroy() {
    window.localStorage.clear();
  },
  getAccessToken() {
    var session = this.getSession();
    return session ? session.accessToken : "";
  }
};
